import PropTypes from "prop-types";
import React from "react";

import { AnswerBubble } from "../AnswerBubble";
import { createClassNameString } from "../utils";
import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";

import "./styles.scss";

export const HorizontalAnswerBubblesQuestionSet = ({
  answers,
  bubbleStyle,
  className,
  optionColStyle,
  questionAnswerClassName,
  questionSetCategory,
  questionSetOptions,
  questionSetOptionsBottomLabels,
  style,
}) => {
  const classNamesArray = ["apti-CL apti-HorizontalAnswerBubblesQuestionSet", className];

  return (
    <div className={createClassNameString(classNamesArray)} style={style}>
      <Text color={TextColors.purple} type={TextTypes.label}>
        {questionSetCategory}
      </Text>

      <div className="apti-HorizontalAnswerBubblesQuestionSetSection apti-HorizontalAnswerBubblesQuestionSetTopOptionLabelContainer">
        <div></div>
        <div>
          <div className="apti-HorizontalAnswerBubblesQuestionSetSubSection">
            {questionSetOptions.map((questionSetOption, optionIndex) => {
              return (
                <div
                  className="apti-HorizontalAnswerBubblesQuestionSetOptionLabelContainer"
                  key={`apti-HorizontalAnswerBubblesQuestionSet-${optionIndex}`}
                >
                  <div
                    className="apti-HorizontalAnswerBubblesQuestionSetOptionLabel"
                    style={optionColStyle}
                  >
                    {questionSetOption}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {Object.entries(answers).map(([question, answerIds]) => {
        return (
          <div
            className={createClassNameString([
              "apti-HorizontalAnswerBubblesQuestionSetSection",
              questionAnswerClassName,
            ])}
            key={`apti-HorizontalAnswerBubblesQuestionSet-${question}`}
          >
            <div>
              <Text>{question}</Text>
            </div>

            <div>
              <div className="apti-HorizontalAnswerBubblesQuestionSetSubSection">
                {questionSetOptions.map((questionSetOption, optionIndex) => {
                  const filled = answerIds.includes(optionIndex);

                  return (
                    <div
                      className="d-flex w-100 tw:justify-center"
                      key={`apti-HorizontalAnswerBubblesQuestionSet-${question}-${optionIndex}`}
                    >
                      <AnswerBubble filled={filled} style={bubbleStyle} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}

      <div className="apti-HorizontalAnswerBubblesQuestionSetSection">
        <div></div>
        <div>
          <div className="apti-HorizontalAnswerBubblesQuestionSetSubSection">
            {questionSetOptionsBottomLabels.map((label, optionIndex) => {
              return (
                <div
                  className="apti-HorizontalAnswerBubblesQuestionSetBottomLabel"
                  key={`apti-QuestionsAnswerSetBottomLabel-${optionIndex}`}
                >
                  {label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

HorizontalAnswerBubblesQuestionSet.propTypes = {
  answers: PropTypes.object,
  bubbleStyle: PropTypes.object,
  className: PropTypes.string,
  optionColStyle: PropTypes.object,
  questionSetCategory: PropTypes.string,
  questionSetOptions: PropTypes.array,
  questionSetOptionsBottomLabels: PropTypes.array,
  style: PropTypes.object,
};

HorizontalAnswerBubblesQuestionSet.defaultProps = {
  answers: {},
  bubbleStyle: {},
  className: undefined,
  optionColStyle: {},
  questionSetCategory: undefined,
  questionSetOptions: [],
  questionSetOptionsBottomLabels: [],
  style: {},
};
